
{
  "familyId": "REK-HANDIG-KEER",
  "questions": [
    {
      "id": "REK-HANDIG-KEER-M03",
      "familyId": "REK-HANDIG-KEER",
      "module": "Basisrekenen",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "handig",
      "subSkill": "handig_vermenigvuldigen",
      "questionType": "multiple_choice",
      "question": "Reken handig uit: 4 × 25. Welke strategie is het handigst?",
      "options": [
        "Herkennen: 4 × 25 = 100 (kwarten van 100)",
        "Splitsen: 4 × 20 = 80, dan 4 × 5 = 20, samen 100",
        "Cijferend: 4 × 5 = 20, schrijf 0, onthoud 2, 4 × 2 + 2 = 10 → 100",
        "Verdubbelen: 2 × 25 = 50, dan 50 × 2 = 100"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Kwarten van 100",
            "content": "25 is een kwart van 100. Dus 4 × 25 = 100. Dit is een standaardproduct dat je uit je hoofd moet kennen: 4 × 25 = 100, net zoals 5 × 20 = 100 en 2 × 50 = 100.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "handig_keer_kwarten",
      "variantIndex": 1,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "4 × 25 = 100. Dit is een standaardproduct: 25 is een kwart van 100, dus 4 × 25 = 100. Alle strategieën geven het juiste antwoord, maar het herkennen van 4 × 25 = 100 is het snelst — je hoeft niet te rekenen!",
        "solutionSteps": [
          "Herken: 25 = ¼ van 100",
          "Dus 4 × 25 = 100",
          "Onthoud: 4 × 25 = 100 is een standaardproduct"
        ],
        "distractorExplanations": {
          "0": "Goed! 4 × 25 = 100 is een standaardproduct. Herkennen is hier de snelste strategie.",
          "1": "Splitsen werkt ook (80 + 20 = 100), maar is meer werk. Als je weet dat 4 × 25 = 100, hoef je helemaal niet te rekenen.",
          "2": "Cijferend rekenen geeft het juiste antwoord, maar is niet 'handig'. Bij handig rekenen zoek je een slimmere weg.",
          "3": "Verdubbelen (2 × 25 = 50, dan × 2 = 100) werkt ook, maar is een omweg. Herkennen dat 4 × 25 = 100 is sneller."
        }
      }
    },
    {
      "id": "REK-HANDIG-KEER-M05",
      "familyId": "REK-HANDIG-KEER",
      "module": "Basisrekenen",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "handig",
      "subSkill": "handig_vermenigvuldigen",
      "questionType": "multiple_choice",
      "question": "Reken handig uit: 8 × 15. Welke strategie is het handigst?",
      "options": [
        "Verdubbelen: 8 × 15 = 4 × 30 = 2 × 60 = 120",
        "Splitsen: 8 × 10 = 80, dan 8 × 5 = 40, samen 120",
        "Cijferend: 8 × 5 = 40, schrijf 0, onthoud 4, 8 × 1 + 4 = 12 → 120",
        "Compenseren: 8 × 20 = 160, dan 160 − 8 × 5 = 160 − 40 = 120"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Verdubbelen en halveren",
            "content": "Bij verdubbelen en halveren maak je één getal groter en het andere kleiner. 8 × 15: halveer 8 → 4, verdubbel 15 → 30. Nu: 4 × 30 = 120. Of nog een keer: 2 × 60 = 120.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "handig_keer_verdubbelen",
      "variantIndex": 2,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Verdubbelen en halveren is hier het handigst: halveer 8 → 4, verdubbel 15 → 30. Nu: 4 × 30 = 120. Je kunt zelfs nog een keer: 2 × 60 = 120. Het product verandert niet als je het ene getal halveert en het andere verdubbelt!",
        "solutionSteps": [
          "Strategie: verdubbelen en halveren",
          "8 × 15 → halveer/verdubbel → 4 × 30",
          "4 × 30 = 120"
        ],
        "distractorExplanations": {
          "0": "Goed! Verdubbelen en halveren: 8 × 15 = 4 × 30 = 120. Slim!",
          "1": "Splitsen (80 + 40 = 120) werkt ook, maar 8 × 5 = 40 is een extra rekenstap. Verdubbelen naar 4 × 30 is sneller.",
          "2": "Cijferend rekenen geeft het juiste antwoord, maar is niet 'handig'. Het doel is een slimmere strategie te kiezen.",
          "3": "Compenseren (160 − 40 = 120) werkt, maar is hier omslachtig. Verdubbelen en halveren is eleganter."
        }
      }
    },
    {
      "id": "REK-HANDIG-KEER-003",
      "familyId": "REK-HANDIG-KEER",
      "module": "Basisrekenen",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "handig",
      "subSkill": "handig_vermenigvuldigen",
      "questionType": "multiple_choice",
      "question": "Reken handig uit: 16 × 25. Welke strategie is het handigst?",
      "options": [
        "Factoren: 16 × 25 = 4 × 4 × 25 = 4 × 100 = 400",
        "Splitsen: 16 × 20 = 320, dan 16 × 5 = 80, samen 400",
        "Verdubbelen: 16 × 25 = 8 × 50 = 4 × 100 = 400",
        "Cijferend: onder elkaar uitrekenen → 400"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Factoren herkennen",
            "content": "16 × 25: splits 16 in factoren: 16 = 4 × 4. Nu: 4 × 4 × 25 = 4 × 100 = 400. Je gebruikt het standaardproduct 4 × 25 = 100!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "handig_keer_factoren",
      "variantIndex": 3,
      "citoDifficulty": 0.44,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "Factoren herkennen is hier het handigst: 16 = 4 × 4, dus 16 × 25 = 4 × (4 × 25) = 4 × 100 = 400. Je combineert factoren om een standaardproduct (4 × 25 = 100) te maken. Dit is de kern van handig vermenigvuldigen!",
        "solutionSteps": [
          "Herken factoren: 16 = 4 × 4",
          "Combineer: 4 × 25 = 100 (standaardproduct)",
          "Reken: 4 × 100 = 400"
        ],
        "distractorExplanations": {
          "0": "Goed! 16 = 4 × 4, dus 4 × (4 × 25) = 4 × 100 = 400. Factoren herkennen is hier de slimste strategie.",
          "1": "Splitsen (320 + 80 = 400) werkt, maar 16 × 20 = 320 en 16 × 5 = 80 zijn allebei rekenstappen. Met factoren heb je maar één stap: 4 × 100 = 400.",
          "2": "Verdubbelen en halveren (8 × 50 = 400 of 4 × 100 = 400) is eigenlijk dezelfde strategie als factoren! Beide zijn goed, maar factoren benoemen is preciezer.",
          "3": "Cijferend rekenen is hier echt onnodig. 16 × 25 = 4 × 100 = 400 — dat kun je in je hoofd!"
        }
      }
    },
    {
      "id": "REK-HANDIG-KEER-004",
      "familyId": "REK-HANDIG-KEER",
      "module": "Basisrekenen",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "handig",
      "subSkill": "handig_vermenigvuldigen",
      "questionType": "fill_in",
      "question": "Reken handig uit: 5 × 48",
      "options": [],
      "correctAnswer": "240",
      "data": {
        "acceptedAnswers": ["240"]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Vermenigvuldigen met 5 — halveren × 10",
            "content": "Vermenigvuldigen met 5 is hetzelfde als halveren en dan × 10. 5 × 48: halveer 48 → 24, dan × 10 = 240. Of: 5 × 48 = 5 × 50 − 5 × 2 = 250 − 10 = 240.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "handig_keer_vijf_halveren",
      "variantIndex": 4,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "5 × 48 = 240. Handige truc: × 5 = halveren en dan × 10. Halveer 48 → 24, dan × 10 = 240. Of compenseer: 5 × 50 = 250, min 5 × 2 = 10, dus 250 − 10 = 240.",
        "solutionSteps": [
          "Strategie: × 5 = halveren × 10",
          "Halveer 48 → 24",
          "24 × 10 = 240"
        ]
      }
    },
    {
      "id": "REK-HANDIG-KEER-005",
      "familyId": "REK-HANDIG-KEER",
      "module": "Basisrekenen",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "handig",
      "subSkill": "handig_vermenigvuldigen",
      "questionType": "multiple_choice",
      "question": "Een timmerman bestelt 12 planken van elk €35. Wat is de totale prijs? Reken handig.",
      "options": ["€420", "€350", "€450", "€385"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Factoren in context",
            "content": "12 × 35: splits 12 in 4 × 3. Nu: 4 × 35 = 140, dan 140 × 3 = 420. Of splits 35: 12 × 30 = 360, plus 12 × 5 = 60, samen 420.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "handig_keer_context_factoren",
      "variantIndex": 5,
      "citoDifficulty": 0.46,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "12 × 35 = 420. Handig: splits 12 in 4 × 3. Eerst 4 × 35 = 140, dan 140 × 3 = 420. Of splits 35: 12 × 30 = 360, plus 12 × 5 = 60 = 420. De timmerman betaalt €420.",
        "solutionSteps": [
          "Herken: 12 × €35",
          "Strategie: splits 12 = 4 × 3",
          "4 × 35 = 140, dan 140 × 3 = 420"
        ],
        "distractorExplanations": {
          "0": "Goed! 12 × 35 = 420. De timmerman betaalt €420 voor de planken.",
          "1": "Je dacht waarschijnlijk aan 10 × 35 = 350. Maar er zijn 12 planken, niet 10. Nog 2 × 35 = 70 erbij: 350 + 70 = 420.",
          "2": "Je dacht waarschijnlijk aan 12 × 37,50 = 450. Maar de planken kosten €35, niet €37,50. 12 × 35 = 420.",
          "3": "Je dacht waarschijnlijk aan 11 × 35 = 385. Maar er zijn 12 planken, niet 11. 12 × 35 = 420."
        }
      }
    }
  ]
}
